import React, { useMemo, useState } from "react"
import { Row, Col, Card, CardBody, Table, CardTitle } from "reactstrap"
import { useTable, usePagination, useGlobalFilter } from "react-table"
import Pagi2 from "common/utils/Pagi2"
import { CommonTableContainer } from "common/utils/ComonTableContainer"
import { Link } from "react-router-dom"
import configure from "configure"

function TableContainer({ columns, data }) {
  const [fixedHeader, setFixedHeader] = useState(false)

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    state,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    gotoPage,
    setPageSize,
    pageOptions,
    setGlobalFilter,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    usePagination
  )

  const { pageIndex, pageSize, globalFilter } = state

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedHeader(true)
    } else {
      setFixedHeader(false)
    }
  })

  // Render the UI for your table
  return (
    <div>
      <Row className="mb-3 justify-content-between">
        <Col md={2}>
          <select
            className="border-radius form-select"
            style={{ width: "100px" }}
            value={pageSize}
            onChange={e => setPageSize(e.target.value)}
          >
            {[10, 20, 30, 40, 50].map(pageSize => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
        </Col>
        <Col md={8} className="d-flex justify-content-end">
          <div>
            <div className="search-box me-xxl-2 my-xxl-0 d-inline-block">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => setGlobalFilter(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="border-radius form-control rounded h-100"
                    placeholder={` Search...`}
                    value={globalFilter || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CommonTableContainer
        columns={columns}
        data={data}
      // status={true}
      />

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagi2
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>
    </div>
  )
}

const ViewContracts = ({ customer_contract }) => {
  // table columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "contract_id",
        isInfoIcon: false,
        className: "contract_id",
        Cell: cellprops => {
          return (
            <div className="text-center">
              {cellprops.row.original?.id}
            </div>
          )
        }
      },
      {
        Header: "Company",
        accessor: "contract_company",
        isInfoIcon: false,
        className: "contract_company ",
        Cell: cellprops => {
          return (
            <div className="text-centers">
              {cellprops.row.original?.customerDetails?.company || "-"}
            </div>
          )
        }
      },
      {
        Header: "Type",
        accessor: "contract_type",
        isInfoIcon: false,
        className: "contract_type",
        Cell: cellprops => {
          return (
            <div className="text-centers">
              {cellprops.row.original?.contractTypes?.contract_type || "-"}
            </div>
          )
        }
      },
      {
        Header: () => {
          return (
            <i className="fas fa-coins"></i>
          )
        },
        accessor: "contract_coins",
        isInfoIcon: false,
        className: "contract_coins",
        Cell: cellProps => {
          return (
            <div className="text-centers">
              {cellProps.row.original.value != null ? (
                <>
                  {cellProps.row.original.currency_symbol}
                  {cellProps.row.original.value}
                </>
              ) : (
                "-"
              )}
            </div>
          )
        }
      },

      {
        Header: "Duration",
        accessor: "contract_duration",
        isInfoIcon: false,
        className: "contract_duration",
        Cell: cellprops => {
          const start = new Date(cellprops.row.original.startdate)
          const end = new Date(cellprops.row.original.enddate)
          var Difference_In_Time = end.getTime() - start.getTime()
          var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24)
          return <div>{Difference_In_Days} days</div>
        }
      },
      {
        Header: "Sent Date",
        accessor: "contract_sent",
        isInfoIcon: false,
        className: "contract_sent text-center",
        Cell: cellprops => {
          return (
            <div className="text-centesr">
              {cellprops.row.original.startdate || "-"}
            </div>
          )
        }
      },
      {
        Header: "End Date",
        accessor: "contract_end",
        isInfoIcon: false,
        className: "contract_end text-center",
        Cell: cellprops => {
          return (
            <div className="text-centers">
              {cellprops.row.original?.enddate || "-"}
            </div>
          )
        }
      },
      // {
      //   Header: "Signature",
      //   accessor: "contract_sign",
      //   isInfoIcon: false,
      //   className: "contract_sign text-center",
      //   Cell: cellprops => {
      //     const status = cellprops.row.original?.signature
      //     return (
      //       status == "not-signed" ? <span className="badge bg-danger text-white" style={{ fontSize: "12px" }}>{cellprops.row.original?.signature}</span>
      //         : status == "signed" ? <span className="badge bg-success text-white" style={{ fontSize: "12px" }}>{cellprops.row.original?.signature}</span>
      //           : null
      //     )

      //   }
      // },
      {
        Header: "Action",
        accessor: "pro_action",
        isInfoIcon: false,
        className: "pro_action",
        Cell: cellProps => {
          return (
            <Link
              to={`${configure.appUrl}/view-contract/${cellProps.row.original.id}`}
              className="btn btn-sm btn-outline-secondary me-1"
              title="View Contract"
            >
              <i className="fas fa-eye "></i>
            </Link>
          )
        }
      },
    ],
    []
  )

  // const data = [
  //   {
  //     contract_id : 1,
  //     contract_company: "Zithas Tchnologies", 
  //     contract_type: "Web Development",
  //     contract_coins: "₹",
  //     contract_duration: "184 days",
  //     contract_sent: "08-12-2024",
  //     contract_end: "18-12-2024",
  //     contract_sign: "Signed"
  //   },
  //   {
  //     contract_id : 2,
  //     contract_company: "Zithas Tchnologies", 
  //     contract_type: "Web Development",
  //     contract_coins: "₹",
  //     contract_duration: "184 days",
  //     contract_sent: "08-12-2024",
  //     contract_end: "18-12-2024",
  //     contract_sign: "Not-Signed"
  //   },
  //   {
  //     contract_id : 3,
  //     contract_company: "Zithas Tchnologies", 
  //     contract_type: "Web Development",
  //     contract_coins: "₹",
  //     contract_duration: "184 days",
  //     contract_sent: "08-12-2024",
  //     contract_end: "18-12-2024",
  //     contract_sign: "Signed"
  //   },
  //   {
  //     contract_id : 4,
  //     contract_company: "Zithas Tchnologies", 
  //     contract_type: "Web Development",
  //     contract_coins: "₹",
  //     contract_duration: "184 days",
  //     contract_sent: "08-12-2024",
  //     contract_end: "18-12-2024",
  //     contract_sign: "Not-Signed"
  //   },
  //   {
  //     contract_id : 5,
  //     contract_company: "Zithas Tchnologies", 
  //     contract_type: "Web Development",
  //     contract_coins: "₹",
  //     contract_duration: "184 days",
  //     contract_sent: "08-12-2024",
  //     contract_end: "18-12-2024",
  //     contract_sign: "Signed"
  //   },


  // ]

  return (
    <React.Fragment>
      <div>
        <div>
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-3 text-dark">Contract</CardTitle>

                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={customer_contract}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ViewContracts
